var Acr = Acr || {};

Acr.StickyNav = function () {
  var $stickyNav;
  var $stickyNavItemsContainer;
  var $stickyNavSentinel;
  var $stickyNavLinks;
  var $mlpNav;
  var $globalNav;
  var $mainWrapper;
  var stickyNavObserver;
  var componentsObserver;
  var resizeTimer;
  var mlpNavHeight;
  var globalNavHeight;
  var stickyNavMobileHeight;
  var stickyNavDesktopWidth;
  var stickyNavHasLook = false;
  var matchMedia;
  const itemsContainerSelectorClass = '.js-sticky-nav-items-container';
  const itemsContainerFixedClass = 'acr-sticky-nav__items-container--fixed';
  const itemsContainerExpandedClass = 'acr-sticky-nav__items-container--expanded';
  const navSentinelSelectorClass = '.js-sticky-nav-sentinel';
  const navLinkSelectorClass = '.js-sticky-nav-link';
  const mlpNavSelectorClass = '.js-mlp-nav';
  const globalNavSelectorClass = '.js-acr-nav';
  const mainWrapperSelectorClass = '.wrapper';
  const mainWrapperCollapsedClass = 'collapsed-nav';
  const activeClass = 'acr-sticky-nav__item--active';
  const look1 = 'acr-sticky-nav--sticky-look-1';
  const stickyNavHeightConstant = 50; // Height in px of the sticky nav when is fixed to the top

  function initSelectors(element) {
    $stickyNav = element;
    $stickyNavItemsContainer = $stickyNav.querySelector(itemsContainerSelectorClass);
    $stickyNavSentinel = $stickyNav.querySelector(navSentinelSelectorClass);
    $stickyNavLinks = $stickyNav.querySelectorAll(navLinkSelectorClass);
    $mlpNav = document.querySelector(mlpNavSelectorClass);
    $globalNav = document.querySelector(globalNavSelectorClass);
    $mainWrapper = document.querySelector(mainWrapperSelectorClass);
  }

  function initGlobalVariables() {
    mlpNavHeight = $mlpNav ? $mlpNav.offsetHeight : 0;
    globalNavHeight = $globalNav ? $globalNav.offsetHeight : 0;
    stickyNavHasLook = $stickyNav.classList.contains(look1);
    matchMedia = window.matchMedia('(min-width: ' + (Constants.breakpoints.lg) + 'px)');
  }

  function initStickyNavObserver() {
    // Options used by the IntersectionObserver assigned to Sticky Nav
    var stickyNavOptions = {
      rootMargin: setRootMarginStickyNavObserver(),
      threshold: [0, 1],
    };

    // Creation of IntersectionObserver assigned to Sticky Nav
    stickyNavObserver = new IntersectionObserver(stickyNavObserverHandler, stickyNavOptions);

    stickyNavObserver.observe($stickyNavSentinel);
  }

  function initComponentsObserver() {
    // Options used by the IntersectionObserver assigned to all the page componentes that activate sticky nav title change
    var componentsOptions = {
      rootMargin: setRootMarginComponentsObserver(),
      threshold: [0, 1],
    };

    // Creation of IntersectionObserver assigned to all the page componentes that activate sticky nav title change
    if (!componentsObserver) {
      componentsObserver = new IntersectionObserver(componentsObserverHandler, componentsOptions);
    }

    // Here all the page componentes that activate sticky nav title change are assigned to the observer
    $stickyNavLinks.forEach(function (link) {
      var componentId = link.getAttribute('data-component-id');
      var $elementToObserve = document.getElementById(componentId);
      if ($elementToObserve) {
        componentsObserver.observe($elementToObserve);
      }
    });
  }

  // Callback function used by the sticky nav observer
  function stickyNavObserverHandler(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio === 0 && (entry.boundingClientRect.top < window.innerHeight)) {
        if (!Utility.isDesktop()) {
          $stickyNav.style.height = '0';
        }
        $stickyNavItemsContainer.classList.add(itemsContainerFixedClass);
        if (!$stickyNavItemsContainer.classList.contains(itemsContainerExpandedClass)) {
          $stickyNavItemsContainer.style.height = stickyNavHeightConstant + 'px';
        }
        $stickyNavItemsContainer.style.width = '100%';
        setStickyTopPosition();
      } else if (entry.intersectionRatio === 1) {
        if (Utility.isDesktop()) {
          if (stickyNavHasLook) {
            $stickyNavItemsContainer.style.removeProperty('width');
          } else {
            $stickyNavItemsContainer.style.width = stickyNavDesktopWidth + 'px';
          }
          $stickyNavItemsContainer.style.removeProperty('height');
        } else {
          setStickyNavHeight();
        }
        $stickyNavItemsContainer.classList.remove(itemsContainerFixedClass);
        $stickyNavItemsContainer.classList.remove(itemsContainerExpandedClass);
        $stickyNavItemsContainer.style.removeProperty('top');
      }
    });
  }

  function setStickyTopPosition() {
    mlpNavHeight = $mlpNav ? $mlpNav.offsetHeight : 0;

    if ($mainWrapper.classList.contains(mainWrapperCollapsedClass)) {
      $stickyNavItemsContainer.style.top = mlpNavHeight + 'px';
    } else {
      globalNavHeight = $globalNav ? $globalNav.offsetHeight : 0;
      $stickyNavItemsContainer.style.top = (globalNavHeight + mlpNavHeight) + 'px';
    }
  }

  function matchMediaHandler() {
    setStickyTopPosition();

    if (matchMedia.matches) {
      // Attachment of resize event for Desktop Size
      window.addEventListener('resize', windowResizeStickyNavHandler);
    } else {
      if ($stickyNavItemsContainer.classList.contains(itemsContainerFixedClass)) {
        stickyNavMobileHeight = 0;
        $stickyNavLinks.forEach(function (link) {
          stickyNavMobileHeight += link.offsetHeight;
        });
      } else {
        setStickyNavHeight();
      }

      // Remove of resize event for mobile size
      window.removeEventListener('resize', windowResizeStickyNavHandler);
    }
  }

  // Callback function used by the general components observer
  function componentsObserverHandler(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        updateLinksStatus(entry.target.id);
      }
    });
  }

  // Function to calculate the top margin used for options in the stickyNav observer
  function setRootMarginStickyNavObserver() {
    var marginTop;
    var marginsString;

    // If $globalNav is collapsed, only take the height of $mlpNav
    if ($mainWrapper.classList.contains(mainWrapperCollapsedClass)) {
      marginTop = mlpNavHeight;
    } else {
      marginTop = mlpNavHeight + globalNavHeight;
    }
    marginsString = '-' + marginTop + 'px 0px 0px 0px';

    return marginsString;
  }

  // Function to calculate the top and bottom margin used for options in the component observer
  function setRootMarginComponentsObserver() {
    var navigatorsHeight;
    var marginTop;
    var marginBottom;
    var marginsString;

    navigatorsHeight = $mlpNav ? mlpNavHeight : globalNavHeight; // If $mlpNav exists, only take the height of $mlpNav (because the global nav is collapse in that case
    marginTop = navigatorsHeight + (stickyNavHeightConstant + 5); // "5px" is added to "stickyNavHeightConstant" to add a little more space and avoid unwanted title changes
    marginBottom = window.innerHeight - navigatorsHeight - (stickyNavHeightConstant * 2); // We multiply "stickyNavHeightConstant" by 2, to have more space to the observer
    marginsString = '-' + marginTop + 'px 0px -' + marginBottom + 'px 0px';

    return marginsString;
  }

  function bindEvents() {
    // Attachment of click events for each of the sticky nav links
    $stickyNavLinks.forEach(function (link) {
      link.addEventListener('click', linkClickHandler);
    });

    // Attachment of resize event for Desktop Size
    if (Utility.isDesktop()) {
      window.addEventListener('resize', windowResizeStickyNavHandler);
    }

    // Using matchMedia to check window size, to avoid window.resize
    matchMedia.addListener(matchMediaHandler);

    // Attachment of "expandedGlobalNav" listener to execute "globalNavChangeHandler" when global nav changes
    document.addEventListener('expandedGlobalNav', globalNavChangeHandler);
  }

  // Function called every time the Global Nav changes from "expanded" or "collapsed" state
  function globalNavChangeHandler() {
    stickyNavObserver.unobserve($stickyNavSentinel);
    initStickyNavObserver();
    setStickyTopPosition();
  }

  // Function that is called when a link is clicked
  function linkClickHandler() {
    event.preventDefault();
    if (!Utility.isDesktop() && $stickyNavItemsContainer.classList.contains(itemsContainerFixedClass) && !$stickyNavItemsContainer.classList.contains(itemsContainerExpandedClass)) {
      document.addEventListener('click', clickOutsideLinkHandler);
      $stickyNavItemsContainer.style.height = stickyNavMobileHeight + 'px';
      $stickyNavItemsContainer.classList.add(itemsContainerExpandedClass);
    } else {
      var clickedComponentId = this.getAttribute('data-component-id');
      var $elementToGo = document.getElementById(clickedComponentId);
      var scrollPosition;
      if ($stickyNavItemsContainer.classList.contains(itemsContainerExpandedClass)) {
        $stickyNavItemsContainer.classList.remove(itemsContainerExpandedClass);
        $stickyNavItemsContainer.style.height = stickyNavHeightConstant + 'px';
      }
      document.removeEventListener('click', clickOutsideLinkHandler);
      if ($elementToGo) {
        updateLinksStatus(clickedComponentId);
        scrollPosition = calculateScrollPosition($elementToGo);
        Utility.scrollTo(scrollPosition, 1000);
      }
    }
  }

  // Function to calculate the scroll position, using the element to go position and adding the global, mlp and sticky navigation heights
  function calculateScrollPosition(element) {
    var elementPosition;
    var stickyNavCurrentHeight;
    var positionToScroll;

    stickyNavCurrentHeight = $stickyNavItemsContainer.offsetHeight;

    if ($stickyNavItemsContainer.classList.contains(itemsContainerFixedClass)) {
      elementPosition = element.offsetTop;
    } else {
      elementPosition = element.offsetTop - stickyNavCurrentHeight;
    }

    if (!$mainWrapper.classList.contains(mainWrapperCollapsedClass)) {
      positionToScroll = elementPosition - globalNavHeight - mlpNavHeight - stickyNavHeightConstant;
    } else {
      positionToScroll = elementPosition - mlpNavHeight - stickyNavHeightConstant;
    }

    return positionToScroll;
  }

  // Function that is called when is clicked outside the sticky navigation while is expanded
  function clickOutsideLinkHandler() {
    event.preventDefault();
    if (!$stickyNavItemsContainer.contains(event.target)) {
      $stickyNavItemsContainer.classList.remove(itemsContainerExpandedClass);
      $stickyNavItemsContainer.style.height = stickyNavHeightConstant + 'px';
      document.removeEventListener('click', clickOutsideLinkHandler);
    }
  }

  // Function to set the new "active" link when the page scrolls or an element is clicked
  function updateLinksStatus(paramTargetComponent) {
    $stickyNavLinks.forEach(function (link) {
      var componentId = link.getAttribute('data-component-id');
      if (componentId === paramTargetComponent) {
        link.parentElement.classList.add(activeClass);
      } else {
        link.parentElement.classList.remove(activeClass);
      }
    });
  }

  // Callback function when resizing occurs on desktop
  function windowResizeStickyNavHandler() {
    // If there's a timer, cancel it
    if (resizeTimer) {
      window.cancelAnimationFrame(resizeTimer);
    }

    // Setup the new requestAnimationFrame()
    resizeTimer = window.requestAnimationFrame(function () {
      stickyNavWidthDesktopHandler();
    });
  }

  function stickyNavWidthDesktopHandler() {
    if (!$stickyNavItemsContainer.classList.contains(itemsContainerFixedClass)) {
      if (!stickyNavHasLook) {
        setStickyNavWidth();
      } else {
        $stickyNav.style.removeProperty('height');
        $stickyNavItemsContainer.style.removeProperty('height');
        $stickyNavItemsContainer.style.removeProperty('width');
      }
    }
  }

  // Sets the size for the sticky nav, height for mobile and tablet and width only for desktop
  function setStickyNavSize() {
    if (Utility.isDesktop()) {
      stickyNavWidthDesktopHandler();
    } else {
      setStickyNavHeight();
    }
  }

  function setStickyNavWidth() {
    stickyNavDesktopWidth = 1;

    $stickyNav.style.removeProperty('height');
    $stickyNavItemsContainer.style.removeProperty('height');
    $stickyNavItemsContainer.style.removeProperty('width');
    $stickyNavLinks.forEach(function (link) {
      stickyNavDesktopWidth += link.parentElement.offsetWidth + 1; // offsetWidth + 1 to add the border right of the li element
    });
    $stickyNavItemsContainer.style.width = stickyNavDesktopWidth + 'px';
  }

  function setStickyNavHeight() {
    stickyNavMobileHeight = 0;
    $stickyNavLinks.forEach(function (link) {
      stickyNavMobileHeight += link.offsetHeight;
    });

    $stickyNavItemsContainer.style.removeProperty('width');
    $stickyNav.style.height = stickyNavMobileHeight + 'px';
    $stickyNavItemsContainer.style.height = stickyNavMobileHeight + 'px';
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    initStickyNavObserver();
    initComponentsObserver();
    setStickyNavSize();
    bindEvents();
  }

  return {
    init: init,
  };
};
